import { render, staticRenderFns } from "./AuthorWrapper.vue?vue&type=template&id=74c279ae&lang=pug&"
import script from "./AuthorWrapper.vue?vue&type=script&lang=js&"
export * from "./AuthorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports